import { render } from "./UtopiaImage.vue?vue&type=template&id=279d945c&scoped=true"
import script from "./UtopiaImage.vue?vue&type=script&lang=js"
export * from "./UtopiaImage.vue?vue&type=script&lang=js"

import "./UtopiaImage.vue?vue&type=style&index=0&id=279d945c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279d945c"]])

export default __exports__